// removed by extract-text-webpack-plugin
module.exports = {"Burger":"Burger__Burger__3K4F-","Paragraph":"Burger__Paragraph__3qhki"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/Burger.css
// module id = 125
// module chunks = 3